import {Component, Input} from '@angular/core';
import {TreatmentShortInfoDto} from '../../../../api/api-client';
import {DateTime} from 'luxon';
import {TranslationPipe} from '../../../../pipes/translation.pipe';
import {SkeletonModule} from 'primeng/skeleton';
import {ButtonModule} from 'primeng/button';
import {RouterModule} from '@angular/router';
import {CardWithHeaderComponent} from '../../../widgets/card-with-header/card-with-header.component';

@Component({
  selector: 'app-dashboard-treatments-list',
  standalone: true,
  imports: [
    TranslationPipe,
    SkeletonModule,
    ButtonModule,
    RouterModule,
    CardWithHeaderComponent
  ],
  templateUrl: './dashboard-treatments-list.component.html',
  styleUrl: './dashboard-treatments-list.component.scss'
})
export class DashboardTreatmentsListComponent {
  @Input() titleKey!: string;
  @Input() emptyMessageKey!: string;
  @Input() treatments: TreatmentShortInfoDto[] = [];
  @Input() areTreatmentsLoaded: boolean = false;

  getDate(date: DateTime) {
    return date.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'});
  }

  getTime(date: DateTime) {
    return date.toLocaleString(DateTime.TIME_24_SIMPLE)
  }
}
